export function Logo(props) {
  return <img src="./logo.svg" alt="" {...props} />;
}
